import {Component, OnInit, OnDestroy,  ViewChild } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { ApiService } from '../../services/api.service';
import { ConfigurationService } from '../../services/configuration.service';
import { ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { DeviceDetectorService } from 'ngx-device-detector';

import { TranslatesService } from './../../services/translates.service';
@Component({
  selector: 'stg-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.scss']
})
export class RankingComponent implements OnInit {
  private subscriptions: any;
  private tripId: number;
  private rankType: string;
  public rankData = [ ];
  public rankDataAllDevices = [ ];
  public scores = [ ];

  deviceInfo = null;
  isMobile = null;
  isDevice = null;
  isMobileDevice = null;
  titleIndex = 'ranking-page-title';

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService,
    public translate: TranslatesService,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle(this.translate.getText(this.titleIndex));
    this.checkDevice();

    this.subscriptions = this.route.params.subscribe(params => {
      this.tripId = +params['id']; // (+) converts string 'id' to a number

      /*this.getRankData(this.rankType, this.tripId);*/
      /*this.getRankDataAllDevices(this.tripId);*/
      this.getRankDataAllDevices(1);
        this.getRankDataAllDevices(2);
    });
  }


/*  public getRankData(tripId, rankType) {
    this.apiService.getRankData(tripId, rankType).subscribe(
        (res: any) => {
          for (const data of res.data) {
            this.rankData.push(data);
          }
          console.log(this.rankData);
        },
        err => console.log(err), // error
        () => {
        }
    );
  }*/
  public getRankDataAllDevices(tripId) {
    this.apiService.getRankDataAllDevices(tripId).subscribe(
      (res: any) => {
        for (const data of res.data) {
          this.rankDataAllDevices.push(data);
        }
      },
      err => console.log(err), // error
      () => {
        this.scores[tripId] = this.rankDataAllDevices.filter( (element) => {
          if (element.trip_id === tripId) {
            return element;
          }
        });
      }
    );
  }

  public checkDevice() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    console.log(this.deviceInfo);
    this.isMobile = this.deviceInfo.os;
    this.isDevice = this.deviceInfo.device;
    if ((this.isMobile.indexOf('windows-phone') >= 0)
        || (this.isMobile.indexOf('android') >= 0)
        || (this.isDevice.indexOf('iphone') >= 0)) {
      this.isMobileDevice = true;
      this.rankType = 'mobile';
      console.log(this.isMobileDevice);
    } else {
      this.isMobileDevice = false;
      this.rankType = 'web';
      console.log(this.isMobileDevice);
    }
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/ranking/ranking.component.ts